var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuEarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fc3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35931",
    "data-name": "Group 35931",
    transform: "translate(-97.508 -229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39637",
    "data-name": "Path 39637",
    className: "cls-1",
    d: "M12,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22ZM12,4a8,8,0,1,0,8,8A8.009,8.009,0,0,0,12,4Z",
    transform: "translate(95.508 227)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26552",
    "data-name": "Group 26552",
    transform: "translate(104.251 234.796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    className: "cls-1",
    d: "M2.385,8.408h0L0,7.031V5.055H2.258v.82L5.151,4.2,2.258,2.533v.82H0V1.377L2.385,0l4.9,2.827V5.581l-4.9,2.827Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuEarn);
export default __webpack_public_path__ + "static/media/menu-earn.43684c61f4ea16fbf2b6851a9621a6e1.svg";
export { ForwardRef as ReactComponent };